import * as JsCookies from 'js-cookie';

export default class Cookies {

  constructor(options = {}) {

    // Options
    options.enabledByDefault = options.enabledByDefault || false;

    // Variables
    this.enabledByDefault = options.enabledByDefault;
    this.isEnabled = false;

    if((this.enabledByDefault && this.consentGiven() === null) || (this.consentGiven())) {
      this.enable();
    }

    // For AlpineJS, we update buttons after a cookie change
    document.addEventListener('cookies', function(){
      setTimeout(function(){
        this.init();
      }.bind(this), 100);
    }.bind(this));

    // setTimeout need for alpine
    setTimeout(function(){
      this.init();
    }.bind(this), 100);

  }

  init() {

    // Elements
    this.bar = document.querySelector('.js-cookies-bar');
    this.acceptBtns = document.querySelectorAll('.js-cookies-btn-accept');
    this.refuseBtns = document.querySelectorAll('.js-cookies-btn-refuse');
    this.resetBtns = document.querySelectorAll('.js-cookies-btn-reset');

    if(!this.bar) {
      console.warn('Cookies bar is not founded !');
      return false;
    }

    // Default visibility
    if(this.consentGiven() != null) {
      this.hideBar();
    }

    // Accept action
    this.acceptBtns.forEach(function(btn){
      btn.onclick = function() {
        this.giveConsent();
        if(!this.isEnabled) this.enable();
        this.hideBar();
      }.bind(this);
    }.bind(this));

    // Refuse action
    this.refuseBtns.forEach(function(btn){
      btn.onclick = function() {
        this.refuseConsent();
        this.disable();
        this.hideBar();
      }.bind(this);
    }.bind(this));

    // Reset action
    this.resetBtns.forEach(function(btn){
      btn.onclick = function() {
        this.clearConsent();
        this.disable();
        this.showBar();
      }.bind(this);
    }.bind(this));

  }

  enable() {
    var event = new CustomEvent('cookies', { 'detail': { 'enabled': true, 'consent': this.consentGiven() } });
    document.dispatchEvent(event);
    this.isEnabled = true;
  }

  disable() {
    let checkEnabled = this.isEnabled;
    this.isEnabled = false;
    var event = new CustomEvent('cookies', { 'detail': { 'enabled': false, 'consent': this.consentGiven() } });
    document.dispatchEvent(event);
  }

  giveConsent() {
    JsCookies.set('cookie-agreed', 1, {expires: 365} );
  }

  refuseConsent() {
    JsCookies.set('cookie-agreed', -1, {expires: 365} );
  }

  clearConsent() {
    JsCookies.remove('cookie-agreed');
  }

  consentGiven() {
    if(typeof JsCookies.get('cookie-agreed') == 'undefined') {
      return null;
    } else {
      return JsCookies.get('cookie-agreed') == 1 ? true : false;
    }
  }

  hideBar() {
    this.bar.style.display = 'none';
  }

  showBar() {
    this.bar.style.display = 'block';
  }

}
